import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { checkOrgPermissions } from '@ui/guards/route-checks';
export const Route = createFileRoute('/org/$organization/settings')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkOrgPermissions(queryClient, params.organization);
        if (!(can === null || can === void 0 ? void 0 : can.updateOrganizationSettings)) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/settings'
                }
            });
        }
    },
    component: RouteComponent
});
function RouteComponent() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
